export const complaintsView: any = {
	complaintsSection: {
	  title: '¿Problemas con el periódico?',
	  action: 'Repórtalo aquí'
	},
	submitNewComplaintModal: {
	  title: 'Reportar situación con periódico',
	  action: 'Reportar situación'
	},
	successNewComplaintResponseModal: {
	  title: 'Reportar situación',
	  body: 'Has reportado tu problema exitosamente.'
	},
	errorNewComplaintResponseModal: {
	  title: 'Reportar situación',
	  body: 'Estamos confrontando dificultades técnicas con el reporte. Para más información, favor de llamar a Servicio al Cliente al 787-641-8800.'
	},
	errorMaxIssueResponseModal: {
	  title: 'Reportar situación',
	  body: 'Hemos recibido el problema sometido anteriormente. No te preocupes, está en nuestro historial.'
	},
	errorNoIssueResponseModal: {
	  title: 'Reportar situación',
	  body: 'No es posible reportar un problema si tu suscripción no incluye entrega del periódico para el día de hoy.'
	},
	noLastSubmittedComplaint: 'No aparece ningún reporte para la suscripción seleccionada.',
	modalActionButtons: {
	  ok: 'OK',
	  cancel: 'Cancelar'
	}
  }
  


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/complaints/complaints.static.data.ts